import { createSlice } from "@reduxjs/toolkit";

import { getComplianceCalendarAction } from "@/redux/complianceCalendar/actions";
import type { ComplianceCalendarType } from "@/redux/complianceCalendar/complianceCalendarType";
import { initialState } from "@/redux/complianceCalendar/initialState";
import { complianceCalendarReducer } from "@/redux/complianceCalendar/reducer";

export const complianceCalendarSlice = createSlice({
  name: "complianceCalendar",
  initialState,
  reducers: complianceCalendarReducer,
  extraReducers: (builder) => {
    builder
      .addCase(
        getComplianceCalendarAction.pending,
        (state: ComplianceCalendarType) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getComplianceCalendarAction.fulfilled,
        (state: ComplianceCalendarType, { payload }) => {
          const { result = {}, status_code, message, success } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              error: message,
              success: 0,
              statusCode: status_code,
            };
          }
          return {
            ...state,
            fetching: false,
            complianceCalendarList: result,
          };
        }
      );
  },
});
export const {
  resetComplianceCalendarList,
  resetComplianceCalendarSuccess,
  resetComplianceCalendarMessage,
  resetComplianceCalendarStatusCode,
  resetComplianceCalendarFetching,
  resetComplianceCalendarError,
} = complianceCalendarSlice.actions;
